import { useEffect, useState } from "react";
import { cdName } from "../lib/filename";
import { toast } from "sonner";
import { Archive, Eye, Download, Search } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const fmt = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");

const getPdf = async (url, name, download) => {
  try {
    const r = await http.get(url, { responseType: "blob" });
    const href = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
    if (download) { const a = document.createElement("a"); a.href = href; a.download = cdName(r.headers["content-disposition"], name); a.click(); }
    else window.open(href, "_blank", "noopener");
    setTimeout(() => URL.revokeObjectURL(href), 60000);
  } catch (e) { toast.error(formatApiError(e)); }
};

// Onglet « Discussions archivées » : liste des discussions closes et leur PDF archivé.
export const ArchivesTab = ({ url, pdf, cols, testid = "archives" }) => {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    const t = setTimeout(() => http.get(url, { params: { q } }).then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e))), 250);
    return () => clearTimeout(t);
  }, [url, q]);
  return (
    <div className="border border-slate-200 bg-white rounded-md" data-testid={testid}>
      <div className="p-3 border-b border-slate-200 flex items-center gap-2 flex-wrap">
        <Archive className="h-4 w-4 text-amber-600" /><span className="text-sm font-bold">Discussions archivées</span>
        <span className="text-xs text-slate-500">PDF généré automatiquement à la clôture, non modifiable</span>
        <label className="ml-auto relative"><Search className="h-3.5 w-3.5 absolute left-2.5 top-2.5 text-slate-400" />
          <input data-testid={`${testid}-search`} value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher…" className="pl-8 pr-3 py-1.5 border border-slate-300 rounded-md text-sm w-56" /></label>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[11px] uppercase tracking-wider text-slate-500"><tr>{cols.map(([l]) => <th key={l} className="text-left px-3 py-2">{l}</th>)}<th className="px-3 py-2 text-left">Clôturée</th><th /></tr></thead>
          <tbody>
            {rows?.map((r) => (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`${testid}-row-${r.id}`}>
                {cols.map(([l, f]) => <td key={l} className="px-3 py-2">{f(r)}</td>)}
                <td className="px-3 py-2 text-xs text-slate-500">{fmt(r.closed_at)}{r.closed_by ? ` · ${r.closed_by}` : ""}</td>
                <td className="px-3 py-2 text-right whitespace-nowrap">
                  <button type="button" data-testid={`${testid}-view-${r.id}`} onClick={() => getPdf(pdf(r), "", false)} className="inline-flex items-center gap-1 text-xs font-semibold text-sky-700 hover:bg-sky-50 rounded px-2 py-1"><Eye className="h-3.5 w-3.5" /> Voir</button>
                  <button type="button" data-testid={`${testid}-dl-${r.id}`} onClick={() => getPdf(pdf(r), `${(r.code || r.agent_name || "discussion").replace(/\W+/g, "_")}.pdf`, true)} className="inline-flex items-center gap-1 text-xs font-semibold text-slate-700 hover:bg-slate-100 rounded px-2 py-1"><Download className="h-3.5 w-3.5" /> PDF</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows && !rows.length && <p className="p-8 text-center text-sm text-slate-500" data-testid={`${testid}-empty`}>Aucune discussion archivée.</p>}
      </div>
    </div>
  );
};

export const ArchiveTabs = ({ tab, setTab, labels = ["Conversations", "Discussions archivées"] }) => (
  <div className="flex gap-1 mb-4 border-b border-slate-200" data-testid="archive-tabs">
    {labels.map((l, i) => (
      <button key={l} type="button" data-testid={`archive-tab-${i}`} onClick={() => setTab(i)}
        className={`px-4 py-2 text-sm font-semibold border-b-2 -mb-px transition-colors ${tab === i ? "border-sky-600 text-sky-700" : "border-transparent text-slate-500 hover:text-slate-800"}`}>{l}</button>
    ))}
  </div>
);
